module.exports = __webpack_public_path__ + "img/19.68f56c7c.png";